const getThemePackSlug = (title?: string) => {
	if (!title) return '';
	return title?.toLowerCase().replace(/ /g, '-');
};

export default getThemePackSlug;
